import { Pipe, PipeTransform } from '@angular/core';

import { formatNumber, NumberFormat } from '../utils/number.format';

@Pipe({
	name: 'copoNumber',
})
export class NumberPipe implements PipeTransform {
	transform(value: number | undefined, format: NumberFormat, unit?: string) {
		return formatNumber(value, format, unit);
	}
}
